//ADDING all the tilesets here in one place

export const CITY_TILESET_ID = 'latimes.syla-2023-cities';
export const CITY_LAYER = 'cities';
// county
export const SUPERVISORS_TILESET_ID = 'latimes.syla-2023-supervisors';
export const SUPERVISORS_LAYER = 'supervisors';
// assembly
export const ASSEMBLY_TILESET_ID = 'latimes.syla-2023-assembly';
export const ASSEMBLY_LAYER = 'assembly';
// senate
export const STATE_SENATE_TILESET_ID = 'latimes.syla-2023-state-senate';
export const STATE_SENATE_LAYER = 'state-senate';
// congressional
export const CONGRESSIONAL_TILESET_ID = 'latimes.syla-2023-congressional';
export const CONGRESSIONAL_LAYER = 'congressional';
//la city council
export const LA_COUNCIL_TILESET_ID = 'latimes.syla-2023-la-council';
export const LA_COUNCIL_LAYER = 'la-council';
//la neighborhood council
export const LA_NEIGHBORHOOD_TILESET_ID = 'latimes.syla-2023-la-neighborhood';
export const LA_NEIGHBORHOOD_LAYER = 'la-neighborhood';

//gardens
// export const GARDENS_TILESET_ID = 'latimes.syla-2023-la-neighborhood';
// export const GARDENS_LAYER = 'syla-2023-gardens-2idk39';

// export const GARDENS_TILESET_ID = 'latimes.4dwv2sjg';
// export const GARDENS_LAYER = 'syla-2023-gardens-2idk39';

export const GARDENS_TILESET_ID = 'latimes.syla-2023-gardens';
export const GARDENS_LAYER = 'syla-2023-gardens';
